export function normalizeUrl(url: string, urlSchema: string) {
    let normalizedUrl = url.toLowerCase().trim();
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
        normalizedUrl = urlSchema.concat(url);
    }
    return normalizedUrl;
}

const urlSchemePattern = /^https?:\/\//i;

export function addUrlSchemeIfMissing(value: string) {
    return urlSchemePattern.test(value) ? value : `https://${value}`;
}

export function removeUrlScheme(value: string) {
    return value.replace(urlSchemePattern, '');
}

const invisibleCharactersPattern = /[\u200b\u200c\u200d\ufeff\u00ad]/g;
const maxCompetitorLength = 500;

// mirrors clean_competitor in ssc.deep.analysis, plus lowercasing and the non-breaking hyphen
export function normalizeCompetitor(value: string) {
    let normalized = value.replace(invisibleCharactersPattern, '').replace(/\u2011/g, '-').trim().toLowerCase();

    if (normalized.length > maxCompetitorLength && urlSchemePattern.test(normalized)) {
        normalized = normalized.split(/[?#]/)[0];
    }

    return normalized;
}

// mirrors is_valid_competitor in ssc.deep.analysis, so the API never rejects what we send
export function isAcceptedCompetitor(value: string) {
    return (
        value.length > 0 &&
        value.length <= maxCompetitorLength &&
        !Array.from(value).some((character) => character.charCodeAt(0) < 32) &&
        !/[\u2011\u200b\u200c\u200d\ufeff\u00ad]/.test(value) &&
        !value.endsWith('#:') &&
        !value.includes('.#') &&
        (value.includes('.') || urlSchemePattern.test(value)) &&
        !/^[.\-_/]+$/.test(value)
    );
}

export function base64ToArrayBuffer(base64: string) {
    const binary_string = window.atob(base64);
    const len = binary_string.length;
    let bytes = new Uint8Array(len);

    for (let i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
    }

    return bytes.buffer;
}

export function shuffleArray<T>(arr: T[]) {
    const copy = [...arr];

    for (let i = copy.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * i);
        const temp = copy[i];
        copy[i] = copy[j];
        copy[j] = temp;
    }
    return copy;
}
